import ReviewQuestion from 'models/reviewQuestion';

export class TemplateRatingDistribution {
  constructor({ PERFORMANCE, POTENTIAL, QNA }) {
    this.PERFORMANCE = PERFORMANCE;
    this.POTENTIAL = POTENTIAL;
    this.QNA = QNA;
  }

  static fromJSON({ PERFORMANCE, POTENTIAL, QNA }) {
    return new TemplateRatingDistribution({
      PERFORMANCE,
      POTENTIAL,
      QNA,
    });
  }
}

export class TemplateSetting {
  constructor({ id, templateId, isEnableGoalLevelQuestion, overallRatingDistribution }) {
    this.id = id;
    this.templateId = templateId;
    this.isEnableGoalLevelQuestion = isEnableGoalLevelQuestion;
    this.overallRatingDistribution = overallRatingDistribution;
  }

  static fromJSON({ id, templateId, isEnableGoalLevelQuestion, overallRatingDistribution = {} }) {
    return new TemplateSetting({
      id,
      templateId,
      isEnableGoalLevelQuestion,
      overallRatingDistribution: TemplateRatingDistribution.fromJSON(overallRatingDistribution),
    });
  }
}

export class TemplateMeta {
  constructor({
    id,
    name,
    formType,
    createdByEmployeeId,
    isArchived,
    questionCount,
    templateSetting,
    ongoingReviewCycleCount,
  }) {
    this.id = id;
    this.name = name;
    this.formType = formType;
    this.createdByEmployeeId = createdByEmployeeId;
    this.isArchived = isArchived;
    this.questionCount = questionCount;
    this.templateSetting = templateSetting;
    this.ongoingReviewCycleCount = ongoingReviewCycleCount;
  }

  static fromJSON({
    id,
    name,
    formType,
    createdByEmployeeId,
    isArchived,
    questionCount,
    templateSetting = {},
    ongoingReviewCycleCount = 0,
  }) {
    return new TemplateMeta({
      id,
      name,
      formType,
      createdByEmployeeId,
      isArchived,
      questionCount,
      templateSetting: TemplateSetting.fromJSON(templateSetting),
      ongoingReviewCycleCount,
    });
  }
}

export class TemplateQuestion {
  constructor({
    id,
    templateId,
    questionType,
    isRequired,
    competencyId,
    displayOrder,
    visibility,
    weightage,
    organizationTag,
    question,
  }) {
    this.id = id;
    this.templateId = templateId;
    this.questionType = questionType;
    this.isRequired = isRequired;
    this.competencyId = competencyId;
    this.displayOrder = displayOrder;
    this.visibility = visibility;
    this.weightage = weightage;
    this.organizationTag = organizationTag;
    this.question = question;
  }

  static fromJSON({
    id,
    templateId,
    questionType,
    isRequired,
    competencyId,
    displayOrder,
    visibility,
    weightage,
    organizationTag,
    question,
  }) {
    return new TemplateQuestion({
      id,
      templateId,
      questionType,
      isRequired: isRequired === undefined || isRequired === null ? true : isRequired,
      competencyId,
      displayOrder,
      visibility,
      weightage: weightage || 0,
      organizationTag,
      question: ReviewQuestion.fromJSON(question),
    });
  }
}
